export type DirectoryRegion = 'US' | 'EU';

export enum DirectorySortingOptions {
  MostDirectoryMembers,
  DirectoryNameAToZ,
  DirectoryNameZToA,
}

export interface Directory {
  id: string;
  readOnly: boolean;
  logoUrl?: string;
  companyName?: string;
  directoryName: string;
  membersCount?: number;
  description?: string;
  categories: string[];
  directoryUrl: string;
}

export interface DirectoriesListResponse {
  directories: Directory[];
}
